module.exports = __webpack_public_path__ + "img/r-icon-3.235faf86.png";